import { Pageable } from "@/model/component.model";
import {
  ExportMetadataDto,
  Filter,
  SearchMetadataDto
} from "@/model/data.model";
import store from "@/vuex/store";
import axios, { AxiosRequestConfig, Method } from "axios";
import { getTenantId } from "./AuthService";

export class SearchService {
  static search(
    microserviceName: string,
    contextId: string,
    conditions: Filter,
    sortBy?: string,
    pageSize?: number,
    page?: number,
    s?: number
  ): Promise<Pageable<any>> {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${store.getters.BASE_API_URL}/${microserviceName}/${contextId}`,
      params: {
        sortBy: sortBy,
        pageSize: pageSize,
        page: page,
        s: s
      },
      data: conditions
    };
    return axios
      .request(config)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        return Promise.reject(err);
      });
  }

  static getMetadataInfo(
    url: string,
    params: any,
    methodType: Method = "GET",
    data?: any
  ) {
    const config: AxiosRequestConfig = {
      method: methodType,
      url: store.getters.BASE_API_URL + url,
      data,
      params: params
    };
    return axios
      .request(config)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }
}
